//
//
//
//
//
//

export default {
  name: 'VCardFooter',
}
